import * as React from 'react';
import { useSelector } from 'react-redux';
import { ImageSources as ImageSourcesComponent } from '../../components/ImageSources';
import { Layout } from '../../components/Layout';
import { getImageSourcesText } from '../../selectors/newbuilding';

export const ImageSources = () => {
  const imageSourcesText = useSelector(getImageSourcesText);

  if (!imageSourcesText) {
    return null;
  }

  return (
    <Layout>
      <ImageSourcesComponent>{imageSourcesText}</ImageSourcesComponent>
    </Layout>
  );
};

ImageSources.displayName = 'ImageSources';
